import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type TransformCtaProps = {
  label: string;
};
export function TransformCta({
  label
}: TransformCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl sm:mt-14" data-id="element-393" data-mp="12sj9usm9c1jv">
      <CtaButton label={label} size="md" data-id="element-394" data-mp="xtg4f72d7tbd" />
      <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[13px] font-medium text-mist" data-id="element-395" data-mp="xuhr68squ48x">
        <li className="flex items-center gap-1.5" data-id="element-396" data-mp="a66wxohjz2tm">
          <ZapIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-397" data-mp="63tt55md9ezh" /> Instant access
        </li>
        <li className="flex items-center gap-1.5" data-id="element-398" data-mp="k3kykhythn1v">
          <LockIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-399" data-mp="k070vn13m20r" /> $27 one-time
        </li>
        <li className="flex items-center gap-1.5" data-id="element-400" data-mp="1vhq6tn62cj30">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-amber" aria-hidden="true" data-id="element-401" data-mp="1vgf29l4sn7au" /> 7-day guarantee
        </li>
      </ul>
    </div>;
}